import { inject, injectable } from 'tsyringe'
import debug from 'debug'
import Tweakpane from 'tweakpane'
import { DebugFlag, SaveKey } from '@/common/constants'
import { Interface } from '@/shared/di/interface'
import type { IDebug } from '@/shared/di/interface/debug'
import type { ISound } from '@/shared/di/interface/sound'
import { FeatureFlagState } from '@/state/vault/domain'

@injectable()
export class DebugManager implements IDebug {
  private isDebugUser = false
  private flagStatus = new Map<DebugFlag, boolean>()
  private flagState = new Map<DebugFlag, FeatureFlagState>()

  pane: Tweakpane
  autoResolveTimeout: any = undefined

  constructor(
    //@inject(Interface.IAssets) private readonly assets: IAssets,
    @inject(Interface.ISound) private readonly sound: ISound
  ) {
    this.pane = new Tweakpane({
      container: document.getElementById('tweakPaneTemp') as HTMLElement,
      expanded: false,
      title: 'Settings'
    })
    this.pane.element.style.width = '310px'
  }

  async init(): Promise<void> {
    debug.disable()

    return Promise.resolve()
  }

  setFlag(flag: DebugFlag, value: boolean, save = true) {
    this.flagStatus.set(flag, value)

    if (flag === DebugFlag.Log) {
      if (value) {
        debug.enable('vault,ws,ws:*,http,http:*,bouncer')
      } else {
        debug.disable()
      }
    } else if (flag === DebugFlag.MuteAudio) {
      this.sound.setGlobalMute(Boolean(value))
    } else if (flag === DebugFlag.Render) {
      this.pane.element.style.display = Boolean(value) === true ? 'block' : 'none'
    } /*else if (flag === DebugFlag.FasterCoinMaterial) {
      this.assets.unloadNamespace('coins')
    }*/
  }

  getFlag(flag: DebugFlag): boolean {
    if (this.flagStatus.has(flag)) {
      return this.isDebug && (this.flagStatus.get(flag) ?? false)
    } else {
      return false
    }
  }

  setState(flag: DebugFlag, value: FeatureFlagState, save = true) {
    this.flagState.set(flag, value)
  }

  getState(flag: DebugFlag): FeatureFlagState {
    if (this.flagState.has(flag)) {
      return this.flagState.get(flag) ?? FeatureFlagState.Default
    } else {
      return FeatureFlagState.Default
    }
  }

  get isDebug(): boolean {
    return this.isDebugUser
  }
}
